<app-tablelayout [data]="logs" [filterItems]="filterOptions" [count]="count" [columns]="columns" [columnsToRemove]="removeColumn" [offset]="25"
    [allowExport]="true" exportFileName="activity-log"
    (loadDataEvent)="loadDataEventHandler($event)"><app-tablelayout/>
